import { motion } from "framer-motion";
import { BlueprintGrid, CrossMarker } from "../components/BlueprintGrid";
import { scrollToSection } from "../lib/site";
import { lineMask, EASE } from "../lib/motion";

const LINES = ["BUILD DURBAN", "WITH BUILDEASE."];

const PilotHero = () => (
    <section
        data-testid="pilot-hero"
        className="relative flex min-h-[82svh] flex-col overflow-hidden bg-ink"
    >
        <BlueprintGrid />
        <CrossMarker className="absolute right-10 top-28 hidden text-white/25 md:block" />

        <div className="relative z-10 mx-auto flex w-full max-w-[1600px] flex-1 flex-col justify-center px-6 pb-20 pt-40 md:px-10 lg:px-16">
            <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
                className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
            >
                <span className="h-1.5 w-1.5 bg-accent" />
                JOIN THE PILOT — DURBAN
            </motion.p>

            <h1
                data-testid="pilot-hero-headline"
                className="mt-8 font-display text-[clamp(2.6rem,7vw,7rem)] font-semibold leading-[1.1] text-white"
            >
                {LINES.map((line, i) => (
                    <span
                        key={line}
                        className="-mb-[0.08em] block overflow-hidden pb-[0.08em]"
                    >
                        <motion.span
                            className="block"
                            variants={lineMask}
                            initial="hidden"
                            animate="show"
                            custom={i}
                        >
                            {i === 1 ? (
                                <>
                                    WITH BUILDEASE
                                    <span className="text-accent">.</span>
                                </>
                            ) : (
                                line
                            )}
                        </motion.span>
                    </span>
                ))}
            </h1>

            <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: EASE, delay: 0.7 }}
                className="mt-8 max-w-xl text-[16px] leading-relaxed text-mist md:text-base"
            >
                We're inviting a small group of Durban homeowners to
                experience BuildEase during its pilot phase.
            </motion.p>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: EASE, delay: 0.85 }}
                className="mt-10"
            >
                <a
                    href="#apply"
                    data-testid="pilot-hero-start-application"
                    onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("#apply");
                    }}
                    className="group inline-flex items-center gap-2 bg-accent px-7 py-4 text-sm font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                >
                    Start Your Application
                    <span className="transition-transform duration-300 group-hover:translate-y-1">
                        ↓
                    </span>
                </a>
            </motion.div>
        </div>

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.1 }}
            className="relative z-10 border-t border-white/10"
            data-testid="pilot-metadata-bar"
        >
            <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-6 px-6 py-4 font-mono text-[13px] tracking-[0.24em] text-mist/80 md:px-10 lg:px-16">
                <span className="hidden sm:block">BUILD INTELLIGENCE</span>
                <span data-testid="pilot-stage-counter">JOIN THE PILOT</span>
                <span>DURBAN — SOUTH AFRICA</span>
                <span className="hidden md:block">29.8587° S / 31.0218° E</span>
            </div>
        </motion.div>
    </section>
);

export default PilotHero;
